import api from './api';

// status: 'pending' | 'reviewed' | 'all'; sort: 'most_reported' | 'latest'
export async function getReportedUsers({ page = 1, limit = 20, status = 'pending', search, sort } = {}) {
  const params = { page, limit };

  if (status) params.status = status;
  if (search) params.search = search;
  if (sort) params.sort = sort;

  const response = await api.get('/admin/reports', { params });
  return response.data;
}

export async function getUserReports(userId) {
  const response = await api.get(`/admin/reports/${userId}`);
  return response.data;
}

// action: 'block' | 'dismiss'; both mark every pending report on the user as reviewed.
export async function reviewUserReports(userId, action) {
  const response = await api.patch(`/admin/reports/${userId}`, { action });
  return response.data;
}
